import styled from 'styled-components';

import { Button, SecondaryButton } from '../../../components';
import { ThemeProp } from '../../../theme/Themes';
import { IconContainer } from '../CustomToast/CustomToast.styles';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const StyledIconContainer = styled(IconContainer)`
  background-color: ${(props: ThemeProp) => props.theme.colors.main.c100};
  stroke: ${(props: ThemeProp) => props.theme.colors.main.c500};
  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const buttonProps = (props: ThemeProp) => `
  height: 2rem;
  flex: 1;
  .nextui-button-text {
    font-size: ${props.theme.fontSize.xs};
    font-weight: ${props.theme.fontWeight.medium};
  }
`;

export const StyledButton = styled(Button)`
  ${buttonProps}
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  ${buttonProps}
`;

export const TimeText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.mobile.caption1.fontSize};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.mobile.caption1.lineHeight};
  letter-spacing: 0.03125rem;
  text-transform: uppercase;
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.low};
`;
